module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-Workspace.b9e09314.jpg";